import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function SosyalAnksiyeteTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['sosyal-anksiyete-testi']} />;
}
